import { Inject, Injectable, Injector } from '@angular/core';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';



@Injectable({ providedIn: 'root' })
export class Document360_OperationService {

  constructor(
    private injector: Injector,
    private $utils: UtilsService,
  ) {
  }

  public Document360: Document360_OperationService = this;


  private isAuthorized(operationName: string): Promise<boolean> {
    return this.$utils.http.post(`${environment.backendUrl}api/Document360/operations/${operationName}/isauthorized`, null);
  }
}
